/* Iznosi novčanih kazni — Zakon o radnom vremenu posade vozila u drumskom prevozu
 * i tahografima ("Sl. glasnik RS" 96/2015, 95/2018), kaznene odredbe čl. 54–61.
 * Kazne su u FIKSNOM iznosu i stepenovane po težini prekršaja (4 nivoa).
 *
 * Nivo → čl. 54 (najteži), 55, 56, 57 (najblaži) za privredne subjekte,
 *        čl. 58–61 za fizičko lice (vozača).
 */

const NIVOI = {
    1: { pravno: 200000, preduzetnik: 120000, odgovorno: 25000, vozac: 50000 },
    2: { pravno: 120000, preduzetnik:  80000, odgovorno: 15000, vozac: 40000 },
    3: { pravno:  60000, preduzetnik:  40000, odgovorno: 10000, vozac: 20000 },
    4: { pravno:  30000, preduzetnik:  20000, odgovorno:  5000, vozac: 10000 },
};

const fmt = (n) => n.toLocaleString('sr-RS');

/** Nivoi sa iznosima — za tab "KAZNE - IZNOSI". */
export const NIVOI_LISTA = [1, 2, 3, 4].map(n => ({ nivo: n, ...NIVOI[n] }));

/* Najteži prekršaji (nivo 1, čl. 51) NE mogu se utvrditi iz DDD podataka o
   aktivnostima — reč je o manipulaciji tahografom, ometanju nadzora i nevođenju
   evidencije. Zato ih nema u listi automatskih prekršaja; navedeni su odvojeno
   da šifarnik bude potpun. */
export const KAZNE_VAN_OBRACUNA = [
    { opis: 'Manipulacija tahografom — izmena, prikrivanje ili brisanje podataka sa listića, iz memorije tahografa ili sa kartice vozača',
      osnov: 'čl. 14 st. 5 / kazna po čl. 51' },
    { opis: 'Posedovanje ili korišćenje uređaja za manipulaciju tahografom',
      osnov: 'čl. 14 st. 6 / kazna po čl. 51' },
    { opis: 'Proizvodnja, distribucija, oglašavanje ili prodaja uređaja za manipulaciju',
      osnov: 'čl. 14 st. 7 / kazna po čl. 51' },
    { opis: 'Neomogućavanje nadzornom organu nesmetanog nadzora u prostorijama prevoznika',
      osnov: 'čl. 15 st. 8 / kazna po čl. 51' },
    { opis: 'Nevođenje evidencije o radnom vremenu posade ili nečuvanje listića i ispisa',
      osnov: 'čl. 4 i 15 / kazna po čl. 51' },
];

/** Koji prekršaj nosi koji nivo (i po kom osnovu). Prati pravila iz aetrMotor.js. */
export const KAZNE_PREGLED = [
    { grupa: 'Dnevni odmor', opis: 'Nedovoljan dnevni odmor (manje od 9h)',
      osnov: 'AETR čl. 8', nivo: 'stepenovano', nivoi: '2–4', napomena: 'odmor <7h → nivo 2; 7–10h → nivo 3; preko 10h → nivo 4' },
    { grupa: 'Dnevni odmor', opis: 'Dnevni odmor nije završen u roku od 24h (radni period duži od 15h)',
      osnov: 'AETR čl. 8', nivo: 'stepenovano', nivoi: '2–4', napomena: 'po odmoru koji je stao u 24h prozor: <7h → 2; 7–10h → 3; preko 10h → 4' },
    { grupa: 'Dnevni odmor', opis: 'Prekoračen broj skraćenih dnevnih odmora (više od 3 između dva nedeljna)',
      osnov: 'AETR čl. 8', nivo: 'stepenovano', nivoi: '2–4', napomena: 'po trajanju odmora: <7h → 2; 7–10h → 3; preko 10h → 4' },
    { grupa: 'Vreme vožnje', opis: 'Prekoračeno dnevno vreme vožnje (preko 10h)',
      osnov: 'AETR čl. 6', nivo: 'stepenovano', nivoi: '1–4', napomena: 'prekoračenje ≥4h30 (50%) → nivo 1; ≥2h → 2; ≥1h → 3; manje → 4' },
    { grupa: 'Vreme vožnje', opis: 'Prekoračen broj produženih dana vožnje (10h više od 2× nedeljno)',
      osnov: 'AETR čl. 6', nivo: 'stepenovano', nivoi: '1–4', napomena: 'isto stepenovanje kao dnevna vožnja' },
    { grupa: 'Vreme vožnje', opis: 'Prekoračeno nedeljno vreme vožnje (preko 56h)',
      osnov: 'AETR čl. 6', nivo: 'stepenovano', nivoi: '1–3', napomena: 'vožnja ≥70h → nivo 1; ≥60h → 2; ostalo → 3' },
    { grupa: 'Vreme vožnje', opis: 'Prekoračeno dvonedeljno vreme vožnje (preko 90h)',
      osnov: 'AETR čl. 6', nivo: 'stepenovano', nivoi: '1–4', napomena: 'vožnja ≥112h30 → nivo 1; ≥105h → 2; ≥100h → 3; ostalo → 4' },
    { grupa: 'Pauza', opis: 'Vožnja duža od 4h30 bez pauze od 45 min (ili 15+30)',
      osnov: 'AETR čl. 7', nivo: 3 },
    { grupa: 'Nedeljni odmor', opis: 'Dva skraćena nedeljna odmora za redom',
      osnov: 'AETR čl. 8', nivo: 2 },
    { grupa: 'Nedeljni odmor', opis: 'Nenadoknađen skraćen nedeljni odmor (rok: tri naredne nedelje)',
      osnov: 'AETR čl. 8', nivo: 2 },
    { grupa: 'Nedeljni odmor', opis: 'Kasno započet nedeljni odmor (posle 6×24h)',
      osnov: 'AETR čl. 8', nivo: 2 },
    { grupa: 'Nedeljni odmor', opis: 'Nema nedeljnog odmora u periodu',
      osnov: 'AETR čl. 8', nivo: 2 },
    { grupa: 'Dnevno radno vreme', opis: 'Preko 14h u 24 časa (bez noćnog rada)',
      osnov: 'Zakon o radnom vremenu posade vozila, čl. 4 st. 2', nivo: 3 },
    { grupa: 'Dnevno radno vreme', opis: 'Preko 10h u 24 časa kada se obavlja noćni rad (00:00–04:00)',
      osnov: 'Zakon o radnom vremenu posade vozila, čl. 4 st. 5', nivo: 3 },
    { grupa: 'Noćna vožnja', opis: 'Noćna vožnja duža od 3h u periodu 00:00–04:00',
      osnov: 'Zakon o radnom vremenu posade vozila', nivo: 3 },
    { grupa: 'Ukupan rad', opis: 'Rad preko 6h bez 30 min pauze / preko 9h bez 45 min pauze',
      osnov: 'Zakon o radnom vremenu posade vozila', nivo: 4 },
    { grupa: 'Istek kartice', opis: 'Vožnja sa isteklom karticom vozača',
      osnov: 'Zakon o radnom vremenu posade vozila', nivo: 4 },
    { grupa: 'Loše upravljanje tahografom', opis: 'Nepoznata aktivnost / kartica nije korišćena kako treba',
      osnov: 'Zakon o radnom vremenu posade vozila', nivo: 4 },
];

/** Tekst kazne za dati nivo težine (1–4). */
export function kaznaTekst(nivo) {
    const n = NIVOI[nivo] || NIVOI[4];
    return `Kazna: pravno lice ${fmt(n.pravno)} RSD, preduzetnik ${fmt(n.preduzetnik)} RSD, `
         + `odgovorno lice ${fmt(n.odgovorno)} RSD, vozač ${fmt(n.vozac)} RSD`;
}

/** Dodaje iznos kazne na kraj poruke o prekršaju. */
export function saKaznom(poruka, nivo) {
    return `${poruka} — ${kaznaTekst(nivo)}`;
}

/* ── Stepenovanje po težini (iz kaznenih odredbi) ───────────────────────── */

/** Dnevno vreme upravljanja (dozvoljeno 9h, izuzetno 10h).
 *  prekoračenje ≥50% → nivo 1; ≥2h → 2; ≥1h → 3; manje → 4. */
export function nivoDnevnaVoznja(prekoracenjeMs, dozvoljenoMs) {
    const H = 60 * 60 * 1000;
    if (dozvoljenoMs && prekoracenjeMs >= dozvoljenoMs * 0.5) return 1;
    if (prekoracenjeMs >= 2 * H) return 2;
    if (prekoracenjeMs >= 1 * H) return 3;
    return 4;
}

/** Nedeljno vreme upravljanja (dozvoljeno 56h). ≥70h → nivo 1. */
export function nivoNedeljnaVoznja(ukupnoMs) {
    const H = 60 * 60 * 1000;
    if (ukupnoMs >= 70 * H) return 1;
    if (ukupnoMs >= 60 * H) return 2;
    return 3;
}

/** Dvonedeljno vreme upravljanja (dozvoljeno 90h).
 *  ≥112h30 → 1; ≥105h → 2; ≥100h → 3; ostalo → 4. */
export function nivoDvonedeljnaVoznja(ukupnoMs) {
    const H = 60 * 60 * 1000;
    if (ukupnoMs >= 112.5 * H) return 1;
    if (ukupnoMs >= 105 * H) return 2;
    if (ukupnoMs >= 100 * H) return 3;
    return 4;
}

/** Dnevni odmor: deo odmora <7h u roku od 24h → nivo 2; 8h30–10h → nivo 3. */
export function nivoDnevniOdmor(odmorMs) {
    const H = 60 * 60 * 1000;
    if (odmorMs < 7 * H) return 2;
    if (odmorMs < 10 * H) return 3;
    return 4;
}

export default NIVOI;
